// src/lib/bankIcons.ts
// Resolve a public /icons/banks/*.png URL for a given bank code or
// "PromptPay". Icons sourced from
// github.com/casperstack/thai-banks-logo (MIT) — see
// scripts/download-bank-icons.sh-equivalent commands in
// public/icons/banks/. Returns null when the bank isn't in the set
// so callers can fall back to a generic placeholder.

// Bank codes we ship icons for. Keep in sync with the files in
// public/icons/banks/. Order doesn't matter — used as a lookup set.
const ICONS = new Set([
  'BAAC', 'BAY', 'BBL', 'CIMB', 'CITI', 'GHB', 'GSB', 'HSBC',
  'IBANK', 'ICBC', 'KBANK', 'KKP', 'KTB', 'LHB', 'SCB', 'TCRB',
  'TISCO', 'TTB', 'UOB',
])

// Aliases — shops may have older / alternative codes stored in DB
// (e.g. "TMB" before TMB+Thanachart merged into TTB; "TCD" used by
// the AI's BANK_LABELS but the icon repo names it "TCRB").
const ALIAS: Record<string, string> = {
  TMB: 'TTB',
  THANACHART: 'TTB',
  TBANK: 'TTB',
  TCD: 'TCRB',
}

/** Return the public path of a bank icon, or null when unknown. */
export function bankIconPath(bankCode: string | null | undefined): string | null {
  if (!bankCode) return null
  const code = ALIAS[bankCode.toUpperCase().trim()] ?? bankCode.toUpperCase().trim()
  if (ICONS.has(code)) return `/icons/banks/${code}.png`
  return null
}

/** PromptPay icon path — separate helper because PromptPay isn't a
 *  bank code; it's the row's own logo. */
export const PROMPTPAY_ICON = '/icons/banks/PromptPay.png'
